module.exports = "mutation UpdateCard($card: UpdateCardInput!) {\n  updateCard(card: $card) {\n    card {\n      ...CardFragment\n    }\n  }\n}\n"